module.exports = __webpack_public_path__ + "img/img_kura_app.b301ffb0.png";